var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5625 5.45679C16.8876 8.51241 17.3943 11.4893 17.565 14.5625C17.6462 16.023 17.7791 17.4675 17.9084 18.916C18.0146 20.1054 18.2166 21.3461 18.2574 22.5273C18.2791 23.1563 18.3571 23.7842 18.3571 24.3994C18.3571 26.02 17.9583 27.609 17.9583 29.2237C17.9583 32.2583 17.8586 35.3967 17.8586 38.4568",
    stroke: "#FCCD33",
    strokeWidth: 10.0186,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 22.8239C12.2717 22.4674 19.7082 22.3037 26.8189 21.3802C28.9764 21.1 30.9384 20.5344 32.9399 20.0485C33.8582 19.8256 34.6084 19.5637 35.5757 19.3994",
    stroke: "#FCCD33",
    strokeWidth: 10.0186,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow);
export default __webpack_public_path__ + "static/media/yellow.8edc659aab707fdf7b6d412d16e38ee3.svg";
export { ForwardRef as ReactComponent };